import baseTheme from "styles/theme"

export default baseTheme
